module.exports = __webpack_public_path__ + "img/wendigo_small.917765e4.png";